// removed by extract-text-webpack-plugin
module.exports = {"disabled":"_2_fs"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Flows/Flows.scss
// module id = +OTl
// module chunks = 0